import React from 'react';
import { theme } from '../../design/theme';

interface ConfirmDialogProps {
  isOpen: boolean;
  onConfirm: (justification: string) => void;
  onCancel: () => void;
  title: string;
  description: string;
  isCritical?: boolean;
  requireJustification?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title,
  description,
  isCritical = false,
  requireJustification = true
}) => {
  const [justification, setJustification] = React.useState('');

  if (!isOpen) return null;

  const handleConfirm = () => {
    if (requireJustification && !justification.trim()) {
      alert('Justification is required for this action');
      return;
    }
    onConfirm(justification);
    setJustification('');
  };

  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: 'rgba(0,0,0,0.5)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      zIndex: 1000,
      padding: theme.spacing.md
    }}>
      <div style={{
        ...theme.card,
        width: '100%',
        maxWidth: '500px',
        padding: theme.spacing.xl,
        borderTop: isCritical ? `4px solid ${theme.colors.critical.main}` : theme.card.border
      }}>
        <h3 style={{ ...theme.typography.h3, marginBottom: theme.spacing.sm }}>
          {title}
        </h3>
        
        <p style={{ ...theme.typography.body, color: theme.colors.neutral[600], marginBottom: theme.spacing.lg }}>
          {description}
        </p>

        {requireJustification && (
          <div style={{ marginBottom: theme.spacing.lg }}>
            <label style={{ 
              ...theme.typography.caption, 
              display: 'block', 
              marginBottom: theme.spacing.xs,
              fontWeight: '600',
              color: theme.colors.neutral[700]
            }}>
              JUSTIFICATION FOR AUDIT LOG
            </label>
            <textarea
              value={justification}
              onChange={(e) => setJustification(e.target.value)}
              placeholder="Provide reason for this high-stakes action..."
              style={{
                width: '100%',
                minHeight: '80px',
                padding: theme.spacing.sm,
                borderRadius: '4px',
                border: `1px solid ${theme.colors.neutral[300]}`,
                fontFamily: theme.typography.fontFamily,
                fontSize: theme.typography.body.fontSize
              }}
            />
          </div>
        )}

        <div style={{ display: 'flex', justifyContent: 'flex-end', gap: theme.spacing.md }}>
          <button 
            onClick={onCancel}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
              borderRadius: '4px',
              border: `1px solid ${theme.colors.neutral[300]}`,
              backgroundColor: 'white',
              cursor: 'pointer',
              ...theme.typography.bodyBold
            }}
          >
            Cancel
          </button>
          <button 
            onClick={handleConfirm}
            style={{
              padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
              borderRadius: '4px',
              border: 'none',
              backgroundColor: isCritical ? theme.colors.critical.main : theme.colors.brand.main,
              color: 'white',
              cursor: 'pointer',
              ...theme.typography.bodyBold
            }}
          >
            Confirm Action
          </button>
        </div>
      </div>
    </div>
  );
};
